'use client'

import { EraserIcon } from 'lucide-react'
import { useEditorContext } from '@/components/ui/editor'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { Button } from '@/components/ui/button'

const ClearFormat = () => {
  const { editor, sourceMode } = useEditorContext()

  const handleClear = () => {
    editor.chain().focus().clearNodes().unsetAllMarks().run()
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type="button"
          size="sm"
          variant="ghost"
          onClick={handleClear}
          title="Clear format"
          disabled={sourceMode}
          tabIndex={-1}>
          <EraserIcon />
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        <p>Clear format</p>
      </TooltipContent>
    </Tooltip>
  )
}

export default ClearFormat
